function IconArrowLeft({
  color = "currentColor",
  style = { width: "24px", height: "24px" },
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
        fill={color}
      />
    </svg>
  );
}

export default IconArrowLeft;
